import type { EnterpriseCloudConfig } from "@app/config/AppConfig";
import EnterpriseApi from "@ext/enterprise/EnterpriseApi";
import type { AvailableCatalog } from "@ext/enterprise/types/AvailableCatalog";
import { GesCloudApi } from "@ext/enterprise-cloud/GesCloudApi";
import type Theme from "@ext/Theme/Theme";

export interface AvailableCatalogsServer {
	url: string;
	list(): Promise<AvailableCatalog[]>;
	logo(repo: string, theme: Theme): Promise<Blob | null>;
}

export const gesServer = (url: string, token: string): AvailableCatalogsServer => {
	const api = new EnterpriseApi(url);
	return {
		url,
		list: () => api.getAvailableCatalogs(token),
		logo: (repo, theme) => api.getCatalogLogo(token, repo, theme),
	};
};

export const gesCloudServer = (url: string): AvailableCatalogsServer => {
	const api = new GesCloudApi(url);
	return {
		url,
		list: () => api.getAvailableCatalogs(),
		logo: (repo, theme) => api.getCatalogLogo(repo, theme),
	};
};

export const getClientServerUrl = (
	enterpriseCloud: EnterpriseCloudConfig,
	gesUrl: string | undefined,
): { url: string; isCloud: boolean } | undefined => {
	if (enterpriseCloud.url && enterpriseCloud.enabled) return { url: enterpriseCloud.url, isCloud: true };
	if (gesUrl) return { url: gesUrl, isCloud: false };
};
